// ES 5

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18nJs = require('i18n-js');

var _i18nJs2 = _interopRequireDefault(_i18nJs);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templateOptions = { interpolate: /%{(.+?)}/, replacement: '%{o.$1}', variable: 'o' };

var memoizedMessage = _lodash2.default.memoize(function (message) {
  message = message.replace(templateOptions.interpolate, templateOptions.replacement);
  return _lodash2.default.template(message, templateOptions);
});

_i18nJs2.default.translations.en = _lodash2.default.merge(_i18nJs2.default.translations.en, require('./locale/en.json'));

_i18nJs2.default.interpolate = function (message, options) {
  options = this.prepareOptions(options);
  return memoizedMessage(message)(options);
};

exports.default = _i18nJs2.default;

// ES 6

// import I18n from 'i18n-js';
// import _ from 'lodash';

// let templateOptions = { interpolate: /%{(.+?)}/, replacement: '%{o.$1}', variable: 'o' };

// const memoizedMessage = _.memoize((message) => {
//   message = message.replace(templateOptions.interpolate, templateOptions.replacement);
//   return _.template(message, templateOptions);
// });

// I18n.translations.en = _.merge(I18n.translations.en, require('./locale/en.json'));

// I18n.interpolate = function(message, options) {
//   options = this.prepareOptions(options);
//   return memoizedMessage(message)(options);
// };

// export default I18n;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/i18n/index.js
// module id = 28
// module chunks = 0